export const PageText = {
  _1: 'Home and Office',
  _2: 'Take ventilation systems, air purifiers or real estate websites to another level with top air quality data at street level. Act first and integrate aircheckr into your service!',
  _3: 'Try it out',
  _4: 'Integrating aircheckr into your service is good for your customers’ health and experience, but is also a potential boost for your revenue and innovative character! Try it out now!'
};

export const Categories = {
  _1: {
    title: "Applications",
    subcategories: [
      {
        key: 0,
        subtitle: 'Ventilation',
        text: 'Since sources of pollution reside in both indoor and outdoor air, aircheckr outside air quality information can help you automate the most appropriate ventilation regime.'
      },
      {
        key: 1,
        subtitle: 'Smart & healthy office and building',
        text: 'Increase the performance and health of your customers’ employees with air quality info, recommendations and alerts.'
      },
      {
        key: 2,
        subtitle: 'Real Estate',
        text: 'Provide information on the air your visitors will breathe the coming 20 years, when they buy or rent a house.'
      },
      {
        key: 3,
        subtitle: 'Purifiers',
        text: 'Make your customers\' and your air purifiers smart with the aircheckr AQ info.'
      }
    ]
  },
  _2: {
    title: 'Ventilation',
    subcategories: [
      {
        key: 0,
        subtitle: 'Most filters do not keep out the most dangerous air pollution',
        text: 'Current ventilation systems often only consider inside air quality for their automation. Although, most systems have filters preventing outside dust and pollen from coming in, they generally fail at keeping out the smallest particles, which are the most dangerous ones.'
      },
      {
        key: 1,
        subtitle: 'Adjust ventilation on the basis of the outside AQ',
        text: 'aircheckr allows to adjust ventilation on the basis of the outside AQ. Our data is machine-readable, empowering automatic adjustement of the ventilation supply. The result is a ventilation product that is performing better, as inside AQ is improved by reducing the supply of low quality air. A detailed study showed that adjusting the ventilation rate to a health-based optimum level provides a spectacular health benefit of 20% reduction of burden of disease. (Asikainen et al., 2014)'
      }
    ]
  },
  _3: {
    title: 'Real estate websites',
    subcategories: [
      {
        key: 0,
        subtitle: 'Air quality is decisive information for visitors',
        text: 'Air quality has the potential to become a new strong discriminating factor in real estate. Clear information on air quality is decisive information for visitors of a real estate website. People at the point of making a vital decision “Where to live fir the next 30 years?”, will definitely want to consider the impact this choice will have on their and their children’s health.'
      }
    ]
  }
};

export const Quotes = [{
  key: 0,
  text: 'Indoor air pollution poses considerable impacts on health and is greatly affected by outdoor air pollution.',
  author: 'Royal College of Physicians, 2016'
},
{
  key: 1,
  text: 'Adjusting  the ventilation rate to a health-based optimum level provides a health benefit of 20% reduction of burder of disease.',
  author: 'Asikainen et al., 2014'
},
{
  key: 2,
  text: 'The annual burden of disease caused by indoor air pollution, incl. outdoor air used to ventilate indoor spaces, is estimated to a loss of over 2 million healthy life years in the EU.',
  author: 'Asikainen et al., 2013'
},
{
  key: 3,
  text: 'Almost 80 % of the total annual burden of disease of indoor exposures in EU-26 is caused by PM2.5, dominated by particulates originating from outdoor air penetrating indoors.',
  author: 'Asikainen et al., 2013'
}];

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/homeandoffice_page.js